// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"delete-1"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M5 5H19L18.5 22H5.5L5 5Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M5 5H19M5 5L5.5 22H18.5L19 5M5 5H3M19 5H21M8.5 2H15.5V5H8.5V2Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M14.8287 10.6716L12.0003 13.5001M12.0003 13.5001L9.17188 16.3285M12.0003 13.5001L9.17188 10.6716M12.0003 13.5001L14.8287 16.3285","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-delete-1')
export default class Delete1Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'delete-1',
    }
  }
}
